import type { TreeTag } from '#domains/tags/types';

export type OptimisticDeletePayload = {
  tag: TreeTag;
};

export const optimisticDelete = (
  state: TreeTag[],
  { tag }: OptimisticDeletePayload
) => {
  const index = state.findIndex(t => t.id === tag.id);

  if (!index) {
    return state;
  }

  const parentTag = state.find(t => t.id === tag.parentId);

  if (parentTag) {
    const siblings = state.filter(t => {
      if (t === tag) return false;

      return parentTag.id === t.parentId;
    });

    // If the tag that is being deleted is the only child of its
    // parent, the parent should be updated to reflect that it
    // has no children.
    if (!siblings.length) {
      state = state.map(t => {
        if (t === parentTag) {
          return {
            ...t,
            hasChildren: false,
            open: false
          };
        }

        return t;
      });
    }
  }

  const start = state.slice(0, index);
  const end = state.slice(index + 1);

  return [...start, ...end];
};
